import { useState, type ReactNode } from 'react';
import type { User } from '../../shared/types';
import { authService } from '../../shared/services';
import { AuthContext } from '../contexts/AuthContext';
import { normalizeUser } from '../../shared/utils/userAdapter';

export function AuthProvider({ children }: { children: ReactNode }) {
  // Inicializa estado com dados do localStorage
  const [token, setToken] = useState<string | null>(() => {
    return localStorage.getItem('auth_token');
  });
  
  const [user, setUser] = useState<User | null>(() => {
    try {
      const storedUser = localStorage.getItem('user');
      if (!storedUser || storedUser === 'undefined' || storedUser === 'null') {
        return null;
      }
      return JSON.parse(storedUser);
    } catch (error) {
      console.error('Erro ao recuperar usuário do localStorage:', error);
      return null;
    }
  });

  const login = async (email: string, password: string) => {
    try {
      console.log('🔐 Iniciando login...');
      const response = await authService.login(email, password);
      console.log('📦 Resposta recebida:', response);
      
      // A API retorna PascalCase (Token, User, ExpiresAt)
      const token = response.Token || response.token;
      const apiUser = response.User || response.user;
      
      console.log('🎫 Token:', token ? 'presente' : 'AUSENTE');
      console.log('👤 User:', apiUser ? 'presente' : 'AUSENTE');
      
      if (!token || !apiUser) {
        throw new Error('Resposta da API inválida: Token ou User ausente');
      }
      
      // Normaliza o usuário para o formato esperado
      const user = normalizeUser(apiUser);
      console.log('✨ User normalizado:', user);
      
      setToken(token);
      setUser(user);
      
      localStorage.setItem('auth_token', token);
      localStorage.setItem('user', JSON.stringify(user));
      
      console.log('✅ Login concluído! isAuthenticated será:', !!token);
    } catch (error) {
      console.error('❌ Erro ao fazer login:', error);
      throw error;
    }
  };

  const logout = async () => {
    await authService.logout();
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        isAuthenticated: !!token,
        isLoading: false,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
